module.exports = __webpack_public_path__ + "static/img/happy-traveling.9c3c4fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/customer/happy-traveling.png
// module id = KydI
// module chunks = 1